import { render, staticRenderFns } from "./SplitterStageRuleRelLimit.vue?vue&type=template&id=e32cbab0&scoped=true"
import script from "./SplitterStageRuleRelLimit.vue?vue&type=script&lang=js"
export * from "./SplitterStageRuleRelLimit.vue?vue&type=script&lang=js"
import style0 from "./SplitterStageRuleRelLimit.vue?vue&type=style&index=0&id=e32cbab0&prod&lang=less&scoped=true"
import style1 from "./SplitterStageRuleRelLimit.vue?vue&type=style&index=1&id=e32cbab0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32cbab0",
  null
  
)

export default component.exports